import { useState } from 'react';

import BankIcon from '@perpay-web/fintech/assets/images/icons/bank-icon.svg';
import { AddBankAccountFlowContainer } from '@perpay-web/fintech/components/composite/AddBankAccountFlow/AddBankAccountFlowContainer';
import { noop } from '@perpay-web/utils/noop';

import styles from './AddBankAccountButton.scss';

/**
 * Add Bank Account Button Component
 * @param {Object} props - Component props
 * @param {Function} [props.onFailure] - Failure handler function
 * @param {Function} [props.onSuccess] - Success handler function
 * @param {Function} [props.onClose] - Close handler function
 * @param {('card')} [props.buttonTheme] - The theme of the button to use for the add bank account button.
 * @param {boolean} [props.skipMFA] - Whether to skip MFA for the add bank account flow.
 * @returns {JSX.Element} Component JSX
 */
export const AddBankAccountButton = ({
    onFailure = noop,
    onSuccess = noop,
    onClose = noop,
    buttonTheme,
    skipMFA,
}) => {
    const [showAddBankAccount, setShowAddBankAccount] = useState(false);

    return (
        <>
            <button
                className={styles['add-bank-button']}
                type='button'
                tabIndex={0}
                onClick={() => setShowAddBankAccount(true)}
                aria-label='Add Bank Account'
            >
                <div className={styles['bank-icon']}>
                    <img src={BankIcon} alt='Bank Icon' />
                </div>
                <div className={styles['bank-name']}>Add Bank Account</div>
                <div className={styles['arrow-icon-container']}>
                    <div className={styles['arrow-icon']} aria-hidden='true' />
                </div>
            </button>
            {showAddBankAccount ? (
                <AddBankAccountFlowContainer
                    buttonTheme={buttonTheme}
                    onClose={() => {
                        setShowAddBankAccount(false);
                        onClose();
                    }}
                    onSuccess={(bank) => {
                        setShowAddBankAccount(false);
                        onSuccess(bank);
                    }}
                    onFailure={() => {
                        setShowAddBankAccount(false);
                        onFailure();
                    }}
                    skipMFA={skipMFA}
                />
            ) : null}
        </>
    );
};
